import { Col, DatePicker, Row, Space, Table, Tag, Flex, Select } from "antd";
import Title from "antd/es/typography/Title";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { getSerieStats } from "../../api/Stats";
import { searchSerie } from "../../api/Search";

const { RangePicker } = DatePicker;

const rangePresets = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
  { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
];

const columns = [
  {
    title: "Nom Série",
    dataIndex: "name",
    key: "nameSerie",
    defaultSortOrder: "descend",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "ID Série",
    dataIndex: "id",
    key: "idSerie",
    render: (text) => <Tag>{text}</Tag>,
  },
  {
    title: "Total Fini",
    dataIndex: "totalFini",
    key: "totalFiniSerie",
    defaultSortOrder: "descend",
    sorter: (a, b) => (Number(a.totalFini) || 0) - (Number(b.totalFini) || 0),
  },
  {
    title: "Total Ouvert",
    dataIndex: "totalOuvert",
    key: "totalOuvertSerie",
    defaultSortOrder: "descend",
    sorter: (a, b) =>
      (Number(a.totalOuvert) || 0) - (Number(b.totalOuvert) || 0),
  },
  {
    title: "Likes",
    dataIndex: "likes",
    key: "likesSerie",
    defaultSortOrder: "descend",
    sorter: (a, b) => (Number(a.likes) || 0) - (Number(b.likes) || 0),
  },
];

const columnsRow = [
  {
    title: "ID saison",
    dataIndex: "id",
    key: "idSaison",
    render: (text) => <Tag>{text}</Tag>,
  },
  {
    title: "#saison",
    dataIndex: "number",
    key: "numberSaison",
    render: (text) => <p>{`#${text}`}</p>,
  },
  { title: "Total Ep", dataIndex: "nbEp", key: "totalEp" },
  {
    title: "Completion",
    dataIndex: "completion",
    key: "completionSaison",
    render: (text) => <p>{`${text}%`}</p>,
  },
  { title: "Total Fini", dataIndex: "totalFini", key: "totalFiniSaison" },
  { title: "Total Ouvert", dataIndex: "totalOuvert", key: "totalOuvertSaison" },
];

const SerieStats = () => {
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [startDate, setStartDate] = useState(dayjs().add(-7, "d"));
  const [endDate, setEndDate] = useState(dayjs());

  const [searchResult, setSearchResult] = useState([]);

  const [dataStats, setDataStats] = useState([]);

  const handleSearch = async (newValue) => {
    const res = await searchSerie(newValue);
    if (res) setSearchResult(res.series);
  };

  const handleChange = (newValue) => {
    if (!selectedSeries.find((s) => s.value === newValue.value)) {
      selectedSeries.push(newValue);
      setSelectedSeries([...selectedSeries]);
    }
  };

  const removeTag = (serie) => {
    const newTags = selectedSeries.filter((s) => s.value !== serie.value);
    setSelectedSeries(newTags);
  };

  const onDatePicked = (value, dateString) => {
    setStartDate(dateString[0]);
    setEndDate(dateString[1]);
  };

  const loadData = useCallback(async () => {
    const res = await getSerieStats(
      selectedSeries.map((s) => s.value),
      startDate,
      endDate
    );
    setDataStats(res);
  }, [endDate, selectedSeries, startDate]);

  useEffect(() => {
    if (selectedSeries.length > 0) loadData();
  }, [selectedSeries, startDate, endDate, loadData]);

  return (
    <>
      <Title level={2}>Statistiques des séries</Title>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <Space direction="vertical" size={12}>
            <RangePicker
              defaultValue={[startDate, endDate]}
              onChange={onDatePicked}
              presets={rangePresets}
            />
          </Space>
        </Col>
        <Col className="gutter-row" span={18}>
          <Select
            style={{ width: "100%" }}
            labelInValue
            showSearch
            placeholder={"Ma super série"}
            defaultActiveFirstOption={false}
            suffixIcon={null}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            notFoundContent={null}
            options={(searchResult || []).map((d) => ({
              value: d.id,
              label: d.name,
            }))}
          />
        </Col>
      </Row>

      <Flex wrap="wrap" gap="small" style={{ marginTop: 32 }}>
        {selectedSeries.map((s) => (
          <Tag key={s.value} closable onClose={() => removeTag(s)}>
            {s.label}
          </Tag>
        ))}
      </Flex>
      {dataStats.length > 0 ? (
        <Table
          style={{ marginTop: 24 }}
          bordered
          columns={columns}
          expandable={{
            expandedRowRender: (serie) => (
              <Table columns={columnsRow} dataSource={serie.seasons} />
            ),
            rowExpandable: (record) => record.name !== "Not Expandable",
          }}
          dataSource={dataStats}
          pagination={false}
          scroll={{
            y: "50vh",
          }}
        />
      ) : null}
    </>
  );
};

export default SerieStats;
